__turbopack_context__.v({
  "className": "sofia_sans_extra_condensed_e213ce84-module__RYXacq__className",
});
